import { useEffect, useRef, useState } from 'react';

import { useIsMounted } from '@uptime/shared/hooks';

export default () => {
  const containerRef = useRef();
  const isMounted = useIsMounted();
  const [containerWidth, setContainerWidth] = useState(0);

  const handleWindowSize = () => {
    if (isMounted) setContainerWidth(containerRef.current && containerRef.current.clientWidth);
  };

  useEffect(() => {
    if (isMounted) window.addEventListener('resize', handleWindowSize);
    return () => window.removeEventListener('resize', handleWindowSize);
  }, []); // eslint-disable-line

  useEffect(() => {
    if (isMounted) handleWindowSize();
    return () => setContainerWidth(0);
  }, [containerRef]); // eslint-disable-line

  return [containerRef, containerWidth];
};
